"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var Utility_1 = require("../Utility");
var IconWrapper = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > svg {\n    height: 100%;\n    width: 100%;\n  }\n"], ["\n  > svg {\n    height: 100%;\n    width: 100%;\n  }\n"])));
var renderIcon = function (icon) {
    if (icon) {
        return react_1.default.createElement(IconWrapper, { className: "t2-icon" }, icon);
    }
    return null;
};
var Sticker = function (props) {
    var _a = (0, Utility_1.handleUtility)(props), className = _a.className, children = _a.children, icon = _a.icon, rest = __rest(_a, ["className", "children", "icon"]);
    return (react_1.default.createElement("span", __assign({ className: (0, classnames_1.default)('t2-sticker', className) }, rest),
        renderIcon(icon),
        children));
};
exports.default = Sticker;
var templateObject_1;
